import React from "react";
import ReactResizeDetector from "react-resize-detector";
import ReactPlayer from "react-player/lazy";
import { makeStyles } from "@material-ui/core/styles";

interface ISize {
  width: number;
  height: number;
}

interface IVideoPlayerProps {
  url: string;
  onProgress?: (state: any) => void;
  playerRef?: any;
}

const calculateHeight = (width: number) => {
  return (width * 9) / 16;
};

const useStyles = makeStyles(() => ({
  videoContainer: {
    border: "1px solid black ",
  },
}));

export const VideoPlayer = ({
  url,
  onProgress,
  playerRef,
}: IVideoPlayerProps) => {
  const classes = useStyles();

  const handleOnProgress = (state: any) => {
    if (onProgress) {
      onProgress(state.playedSeconds);
    }
  };

  return (
    <ReactResizeDetector handleWidth>
      {({ width }: ISize) => {
        return (
          <div className={classes.videoContainer}>
            <ReactPlayer
              ref={playerRef}
              url={url}
              width={width}
              height={calculateHeight(width) || 0}
              controls
              onProgress={handleOnProgress}
              progressInterval={500}
            />
          </div>
        );
      }}
    </ReactResizeDetector>
  );
};
